import React, { useState } from "react";
import { Modal, Form, Input, Button, message } from "antd";
import { postRequest } from "../service";
import { getEmployeeData } from "../utils/localStorage"
import {  useNavigate } from "react-router-dom";

const ChangePasswordModal = ({ open, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const userData = getEmployeeData();
  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    if (values.newPassword !== values.confirmPassword) {
      message.error("New password and confirm password do not match!");
      return;
    }

    setLoading(true);
    try {
      let response = null;
      if(userData.role === "companyadmin")
      {
        response = await postRequest("/api/companies/changepassword", {
          currentPassword: values.currentPassword,
          newPassword: values.newPassword,
        });
      }
      else{
        response = await postRequest("/api/employees/changepassword", {
          currentPassword: values.currentPassword,
          newPassword: values.newPassword,
        });
      }

      if (response.success) {
        message.success("Password changed successfully!");
        form.resetFields();
        onClose();
         localStorage.removeItem("data");
        localStorage.removeItem("token");
        navigate("/");
      } else {
        message.error(response.message || "Failed to change password");
      }
    } catch (error) {
      console.error("Error changing password:", error);
      message.error("An error occurred while changing password");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Change Password"
      open={open}
      onCancel={handleCancel}
      footer={null}
      centered
      width={400}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Form.Item
          name="currentPassword"
          label="Current Password"
          rules={[
            {
              required: true,
              message: "Please enter your current password!",
            },
          ]}
        >
          <Input.Password placeholder="Enter current password" />
        </Form.Item>

        <Form.Item
          name="newPassword"
          label="New Password"
          rules={[
            {
              required: true,
              message: "Please enter your new password!",
            },
            {
              min: 6,
              message: "Password must be at least 6 characters!",
            },
          ]}
        >
          <Input.Password placeholder="Enter new password" />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label="Confirm New Password"
          rules={[
            {
              required: true,
              message: "Please confirm your new password!",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("The two passwords do not match!")
                );
              },
            }),
          ]}
        >
          <Input.Password placeholder="Confirm new password" />
        </Form.Item>

        <Form.Item className="mb-0">
          <div className="flex justify-end gap-2">
            <Button onClick={handleCancel}>Cancel</Button>
            <Button type="primary" className="bg-primary text-white" htmlType="submit" loading={loading}>
              Change Password
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal; 